import { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import TextInputGroup from './TextInputGroup'
import check from '../../assets/images/check-mark-button.svg'
import remove from '../../assets/images/remove.svg'
import { validURL } from '../../helpers/utils'

const StyleForm = styled.div`
  background: var(--white);
  width: 25rem;
  border: 1px solid #000;
  border-radius: 0.3rem;
  -webkit-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 10px 10px 5px 0px rgba(0, 0, 0, 0.75);

  form {
    display: grid;
    grid-gap: 1rem;
    width: 100%;
    margin: 2rem 1rem 1rem 2rem;
  }

  input {
    width: 80%;
  }
  .form-group {
    margin: 0rem;
  }

  button {
    position: relative;
    border: none;
    background: transparent;
    left: 60%;
    cursor: pointer;
  }
`

class InserLinkForm extends Component {
  state = {
    id: '',
    name: '',
    url: '',
    errors: {}
  }

  componentDidMount = () => {
    const { id, name, url } = this.props
    this.setState({
      id,
      name,
      url
    })
  }

  onValueChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit = (e) => {
    e.preventDefault()
    const { id, name } = this.state
    let { url } = this.state

    if (name === '') {
      this.setState({ errors: { name: 'Name is required' } })
      return
    }
    if (url === '') {
      this.setState({ errors: { url: 'URL is required' } })
      return
    }
    if (!validURL(url)) {
      this.setState({ errors: { url: 'Not valid URL' } })
      return
    }

    if (!/^https?:\/\//i.test(url)) {
      url = `http://${url}`
    }

    if (!id) {
      const newLink = {
        id: Math.uuid(),
        name,
        url
      }
      this.props.createUserLink(newLink)
      this.setState({
        name: '',
        url: '',
        errors: {}
      })
    } else {
      const { id, name, url } = this.state
      const updatedLink = {
        id,
        name,
        url
      }
      this.props.updateUserLink(updatedLink)
    }
  }

  render() {
    const { name, url, errors } = this.state
    const { toggleAddForm, labels } = this.props
    const nameLabel = labels !== undefined ? labels[0] : ''
    const linkLabel = labels !== undefined ? labels[1] : ''
    return (
      <StyleForm>
        <form onSubmit={this.onSubmit}>
          <TextInputGroup
            label={nameLabel}
            name="name"
            type="text"
            value={name}
            placeholder="Text to display"
            onChange={this.onValueChange}
            error={errors.name}
          />
          <TextInputGroup
            label={linkLabel}
            name="url"
            type="text"
            value={url}
            placeholder="https://www.example.com"
            onChange={this.onValueChange}
            error={errors.url}
          />
          <div id="control-buttons">
            <button onClick={this.onSubmit}>
              <img
                src={check}
                alt="confirm"
                className="handle"
                width="25px"
                height="25px"
              />
            </button>
            <button onClick={toggleAddForm}>
              <img
                src={remove}
                alt="cancel"
                className="handle"
                width="25px"
                height="25px"
              />
            </button>
          </div>
        </form>
      </StyleForm>
    )
  }
}

InserLinkForm.propTypes = {
  toggleAddForm: PropTypes.func,
  id: PropTypes.string,
  name: PropTypes.string,
  url: PropTypes.string,
  updateUserLink: PropTypes.func,
  createUserLink: PropTypes.func
}

export default InserLinkForm
